import api from "./api"


// =========================================================
// Helpers
// =========================================================

const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) =>
        value !== undefined &&
        value !== null &&
        value !== "" &&
        value !== "all"
    )
  )


const unwrap = (response) =>
  response?.data ?? response


// =========================================================
// Départements
// =========================================================

export const getDepartments = async (params = {}) => {
  const response = await api.get(
    "/hr/departments",
    {
      params: cleanParams(params),
    }
  )

  return unwrap(response)
}


export const getHrDepartments = getDepartments


export const listDepartments = getDepartments


export const getDepartmentList = getDepartments


export const createDepartment = async (payload) => {
  const response = await api.post(
    "/hr/departments",
    payload
  )

  return unwrap(response)
}


export const createHrDepartment = createDepartment


export const addDepartment = createDepartment


export const updateDepartment = async (
  id,
  payload
) => {
  const response = await api.put(
    `/hr/departments/${id}`,
    payload
  )

  return unwrap(response)
}


export const updateHrDepartment = updateDepartment


export const editDepartment = updateDepartment


export const updateDepartmentStatus = async (
  id,
  payload
) => {
  const response = await api.patch(
    `/hr/departments/${id}/status`,
    payload
  )

  return unwrap(response)
}


export const changeDepartmentStatus =
  updateDepartmentStatus


export const setDepartmentStatus =
  updateDepartmentStatus


// =========================================================
// Postes
// =========================================================

export const getPositions = async (params = {}) => {
  const response = await api.get(
    "/hr/departments/positions",
    {
      params: cleanParams(params),
    }
  )

  return unwrap(response)
}


export const getJobPositions = getPositions


export const getHrPositions = getPositions


export const getHrJobPositions = getPositions


export const listPositions = getPositions


export const createPosition = async (payload) => {
  const response = await api.post(
    "/hr/departments/positions",
    payload
  )

  return unwrap(response)
}


export const createJobPosition = createPosition


export const createHrJobPosition = createPosition


export const addPosition = createPosition


export const updatePosition = async (
  id,
  payload
) => {
  const response = await api.put(
    `/hr/departments/positions/${id}`,
    payload
  )

  return unwrap(response)
}


export const updateJobPosition = updatePosition


export const updateHrJobPosition = updatePosition


export const editPosition = updatePosition


export const updatePositionStatus = async (
  id,
  payload
) => {
  const response = await api.patch(
    `/hr/departments/positions/${id}/status`,
    payload
  )

  return unwrap(response)
}


export const changePositionStatus =
  updatePositionStatus


export const setPositionStatus =
  updatePositionStatus


// =========================================================
// Données de formulaire RH
// =========================================================

export const getFormData = async () => {
  const response = await api.get(
    "/hr/departments/form-data"
  )

  return unwrap(response)
}


export const getDepartmentFormData =
  getFormData


export const getHrDepartmentFormData =
  getFormData


// =========================================================
// Export optionnel
// =========================================================

const hrDepartmentService = {
  getDepartments,
  getHrDepartments,
  listDepartments,
  getDepartmentList,

  createDepartment,
  createHrDepartment,
  addDepartment,

  updateDepartment,
  updateHrDepartment,
  editDepartment,

  updateDepartmentStatus,
  changeDepartmentStatus,
  setDepartmentStatus,

  getPositions,
  getJobPositions,
  getHrPositions,
  getHrJobPositions,
  listPositions,

  createPosition,
  createJobPosition,
  createHrJobPosition,
  addPosition,

  updatePosition,
  updateJobPosition,
  updateHrJobPosition,
  editPosition,

  updatePositionStatus,
  changePositionStatus,
  setPositionStatus,

  getFormData,
  getDepartmentFormData,
  getHrDepartmentFormData,
}


export default hrDepartmentService